import { SxProps, Theme, Typography } from '@mui/material'
import React from 'react'

interface Props {
    errorMessage: string
    styles?: SxProps<Theme>
}

const InputErrorPopUp = ({ errorMessage, styles }: Props) => {
    const containerStyle = {
        color: 'custom.errorRed',
        ...styles,
    }
    return (
        <>
            {errorMessage.length > 0 && (
                <Typography
                    variant="subtitle1"
                    sx={containerStyle}
                    data-testid="invalid-pin-error">
                    {errorMessage}
                </Typography>
            )}
        </>
    )
}

export default InputErrorPopUp
